// @ts-nocheck
/* eslint-disable jsdoc/tag-lines */
/* eslint-disable max-classes-per-file */

import Base, { ErrorBase } from 'requests/objects/_base'
import Address from 'requests/objects/address'
import File from 'requests/objects/file'
import WorkflowHistoric from 'requests/objects/workflowHistoric'
import EWorkflowStep from 'types/orders/enums/workflowStep'
import Merchandise from 'requests/objects/merchandise'
import OrderQuotePricing from 'requests/objects/order-quote-pricing'

/**
 * Order Object
 */
export default class OrderQuote extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.orderQuoteId orderQuoteId
     * @param {object=} data.pickupAddress address
     * @param {number=} data.pickupAddressId addressId
     * @param {string=} data.pickupStartDate startDate
     * @param {number=} data.pickupVehicleEquipmentId vehicleEquipmentId
     * @param {number=} data.pickupAccessibilityId accessibilityId
     * @param {string=} data.pickupRequirement pickupRequirement
     *
     * @param {object=} data.deliveryAddress address
     * @param {number=} data.deliveryAddressId addressId
     * @param {string=} data.deliveryStartDate startDate
     * @param {string=} data.deliveryEndDate endDate
     * @param {number=} data.deliveryVehicleEquipmentId vehicleEquipmentId
     * @param {number=} data.deliveryAccessibilityId accessibilityId
     * @param {string=} data.deliveryRequirement deliveryRequirement
     *
     * @param {object[]=} data.merchandises merchandises
     *
     * @param {string=} data.orderingPartyReference orderingPartyReference
     *
     * @param {object[]=} data.files files
     * @param {object[]=} data.workflowHistorics workflowHistorics
     * @param {object[]=} data.orderQuotePricings orderQuotePricings
     * @param {number=} data.orderQuoteNumber orderQuoteNumber
     * @param {string|null=} data.fileToken token file used for upload(uuid front)
     * @param {string} data.expirationDate expiration date
     * @param {object} data.client client
     * @param {object} data.createdByUser createdByUser
     */
    constructor({
        orderQuoteId = 0,
        client,
        createdByUser,
        fileToken = null,
        pickupAddressId = 0,
        pickupAddress,
        pickupStartDate,
        pickupVehicleEquipmentId = 0,
        pickupAccessibilityId = 0,
        deliveryAddressId = 0,
        pickupRequirement = '',
        deliveryAddress,
        deliveryStartDate,
        deliveryEndDate,
        deliveryVehicleEquipmentId = 0,
        deliveryAccessibilityId = 0,
        deliveryRequirement = '',
        merchandises = [],
        orderingPartyReference = '',
        files = [],
        workflowHistorics = [],
        orderQuotePricings = [],
        orderQuoteNumber,
        expirationDate,
        ...data
    } = {}) {
        super(data)
        this.orderQuoteId = orderQuoteId
        this.client = client ?? null
        this.createdByUser = createdByUser ?? null
        this.fileToken = fileToken
        this.orderQuoteNumber = orderQuoteNumber || null
        this.expirationDate = expirationDate ? new Date(expirationDate) : null
        this.pickupAddress = pickupAddress ? new Address(pickupAddress) : null
        this.pickupAddressId = pickupAddressId
        this.pickupStartDate = pickupStartDate ? new Date(pickupStartDate) : null
        this.pickupVehicleEquipmentId = pickupVehicleEquipmentId
        this.pickupAccessibilityId = pickupAccessibilityId
        this.pickupRequirement = pickupRequirement

        this.deliveryAddress = deliveryAddress ? new Address(deliveryAddress) : null
        this.deliveryAddressId = deliveryAddressId
        this.deliveryStartDate = deliveryStartDate ? new Date(deliveryStartDate) : null
        this.deliveryEndDate = deliveryEndDate ? new Date(deliveryEndDate) : null
        this.deliveryVehicleEquipmentId = deliveryVehicleEquipmentId
        this.deliveryAccessibilityId = deliveryAccessibilityId
        this.deliveryRequirement = deliveryRequirement

        this.orderingPartyReference = orderingPartyReference

        this.merchandises = merchandises?.map(x => new Merchandise(x)) ?? []

        this.files = files?.map(x => new File(x)) ?? []

        this.workflowHistorics = workflowHistorics?.length > 0 ? workflowHistorics.map(x => new WorkflowHistoric(x)) : []
        this.currentWorkflow = this.workflowHistorics?.find(x => x.isActive) ?? this.workflowHistorics
            .slice()
            .sort((a, b) => a.position - b.position)
            .at(-1) ?? null
        this.currentWorkflowStepId = this.currentWorkflow?.workflowStepId ?? EWorkflowStep.Creation

        this.orderQuotePricings = orderQuotePricings?.map(x => new OrderQuotePricing(x)) ?? []
    }

    /**
     * Méthode statique pour calculer le total
     * @param {OrderQuotePricing[]} orderQuotePricings orderQuotePricings
     * @returns {number} total
     */
    static getTotal(orderQuotePricings) {
        return orderQuotePricings.reduce((acc, quotePricing) => acc + (quotePricing.costExcludingVat * quotePricing.quantity), 0)
    }

    /**
     * Méthode statique pour calculer le total avec TTC
     * @param {OrderQuotePricing[]} orderQuotePricings orderQuotePricings
     * @returns {number} total price
     */
    static getTotalPrice(orderQuotePricings) {
        return orderQuotePricings.reduce(
            (acc, quotePricing) => acc + ((quotePricing.costExcludingVat * quotePricing.quantity * quotePricing.vat) / 100),
            OrderQuote.getTotal(orderQuotePricings),
        )
    }
}

/**
 * User Object used to bind error message
 */
export class ErrorOrderQuote extends ErrorBase {
    constructor() {
        super()
        this.orderId = ''
        this.orderQuoteId = ''
        this.pickupAddressId = ''
        this.pickupStartDate = ''
        this.pickupVehicleEquipmentId = ''
        this.pickupAccessibilityId = ''
        this.pickupRequirement = ''
        this.deliveryAddressId = ''
        this.deliveryStartDate = ''
        this.deliveryEndDate = ''
        this.deliveryVehicleEquipmentId = ''
        this.deliveryAccessibilityId = ''
        this.deliveryRequirement = ''
        this.orderingPartyReference = ''
        this.merchandises = ''
    }
}
